import React, { useCallback } from 'react'

export const useTeams = () => {

  const flattenTeams = useCallback(({ teams }) => {
    return _.mapValues(teams, (team) => {
      const { record = {} } = team

      const _team = {
        name: team.name,
        sections: team.sections,
        levels: team.levels,
      }

      const _record = {
        mp: record.mp,
        l: record.l,
        w: record.w,
        sl: record.l,
        sw: record.sw,
        owp: record.owp != null ? record.owp.toFixed(2) : '0.00',
        swp: record.swp != null ? record.swp.toFixed(2) : '0.00',
        sectionRank: record.sectionRank,
        playofFRank: record.playofFRank,
        smp: record.smp,
        tm: record.tm,
      }

      return {
        ..._team,
        ..._record
      }
    })
  }, [])

  const sortTeams = useCallback(({ teams }) => {
    return _.orderBy(
      teams,
      ['levels', 'sections', 'sectionRank'],
      ['desc', 'asc', 'asc']
    )
  }, [])

  return { flattenTeams, sortTeams }

}
